package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Category(
    @SerialName("color")
    val color: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("__typename")
    val typename: String?
)